import { inject, Injectable } from '@angular/core';
import { AbstractControl, AsyncValidator, ValidationErrors } from '@angular/forms';
import { PersonServiceInterface, PERSON_SERVICE_TOKEN } from '@campus/dal';
import { Observable, of } from 'rxjs';
import { catchError, mapTo } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class ValidPasswordValidator implements AsyncValidator {
  private personService: PersonServiceInterface = inject(PERSON_SERVICE_TOKEN);

  public validate(ctrl: AbstractControl, userId: number = -1): Observable<ValidationErrors | null> {
    return this.personService.validatePassword(userId, ctrl.value).pipe(
      mapTo(null),
      catchError((err) => {
        const errorContext = err.message.errors[0];

        switch (errorContext.reason) {
          case 'NO_CONTEXT':
            return of({ 'no-context': true });
          case 'NO_USER_INFO':
            return of({ 'no-user-info': true });
          default:
            return of({ 'unknown-error': true });
        }
      })
    );
  }
}
